import React from 'react';
import ReportingBookingHoldsPage from '../components/ReportingBookingHoldsPage';

const ReportingBookingHoldsApp = (props) => (
  <ReportingBookingHoldsPage {...props} />
);

export default ReportingBookingHoldsApp;
